<template>
  <div class="reg-ate-config-status" :data-time='time'>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="Object.keys(buttonForm).length >= 1" class="button">
        <RF-Button 
          :cpntId='buttonForm.id'
          :cpntStatus='buttonForm.status' 
          :cpntTexto='buttonForm.texto' 
          :cpntClass='buttonForm.class' 

          @onClickButton='buttonForm.onClick'
        ></RF-Button>
      </div>

      <RF-Tabela v-if="Object.keys(tabela).length >= 1"
        :data-time='time'
        :cpntTime='time'
        :cpntId='tabela.id'
        :cpntStatus='tabela.status'
        :cpntButtonImprimir='tabela.acoes.btImprimir'
        :cpntButtonAtualizar='tabela.acoes.btAtualizar'
        :cpntFraseTop='tabela.fraseTop'
        :cpntColuna='tabela.coluna'
        :cpntLinha='tabela.linha'
        :cpntCountAll='tabela.countAll'
        :cpntColspan='tabela.colspan'
        :cpntButtonsAcoes='tabela.acoes.buttons'
        :cpntMper='tabela.mper'
        :cpntPagina='tabela.pagina'
        :cpntCheckboxEditar='tabela.checkboxEditar'
        :cpntFieldsEditar='tabela.acoes.fields'

        :cpntOnRefreshTabela='regAteConfigStatusTabelaIniciar'
        :cpntOnCheckboxAtualiza='regAteConfigStatusTabelaOnCheckboxAtualiza'

        :ref='tabela.id'
      ></RF-Tabela>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario='regAteConfigStatusFecharFormulario'></router-view>
  </div>
</template>

<style scoped>
  .reg-ate-config-status > .button {
    margin-bottom: 10px;
  }
</style>

<style>
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        buttonForm: {},
        tabela: {},
        checkbox: []
      }
    },
    mounted: function () {
      this.regAteConfigStatusIniciar()
    },
    methods: {
      regAteConfigStatusFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.regAteConfigStatusTabelaIniciar()
        }
      },
      regAteConfigStatusIniciar: function () {
        var self = this

        // SETA O STATUS DA PAGINA
        self.regAteConfigStatusSetaStatusGeral('carregando')

        // SETA O BOTÃO PARA STATUS
        self.buttonForm = {
          status: '',
          id: 'pet-form-novo',
          texto: 'Nova status',
          class: [ 'btn', 'btn-info', 'btn-md' ],
          onClick: function () {
            self.regAteConfigStatusAbrirFormulario(0)
          }
        }

        // CHAMA A FUNÇÃO PARA CARREGAR A TABELA
        self.regAteConfigStatusTabelaIniciar()
      },
      regAteConfigStatusSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteConfigStatusTabelaIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'reg-ate-forma-contato',
          montarTabelaCompleta: false,
          acoes: {
            buttons: [
               { tipo: 'editar', class: 'btn btn-warning btn-sm', tipoEditar: { 'formularioGeral': self.regAteConfigStatusAbrirFormulario } },
               { tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.regAteConfigStatusDeletarRegistro }
            ]
          }
        }

        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox', chave: 'id' },
          { mPer: 2, chave: 'id', nome: 'Cód.' },
          { mPer: 2, chave: 'nome', nome: 'Nome' },
          { mPer: 2, chave: '_notificar', nome: 'Notificar?' },
          { mPer: 2, chave: '_last_at', nome: 'Última Alteração' },
        ]

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // BUSCA OS REGISTROS NA API
        self.regAteConfigStatusTabelaBuscaRegistro(function (dados) {
          // REALIZA O FOR PARA CRIAR OS CAMPOS PERSONALIZADOS
          for (var key in dados) {
            // SETA OS DADOS DA ULTIMA ALTERAÇÃO
            dados[key]._last_at = [ dados[key].last_user_usuario + '<br/>' + dados[key].last_at_ptbr ]

            // CONVERTE O VALOR RECEBIDO
            dados[key]._notificar = [ '', null, undefined, false, 'false', 'n', 0, '0' ].indexOf(dados[key].notificar) === -1 ? 'Sim' : 'Não'
          }

          // SETA AS LINHAS DA TABELA
          self.tabela.linha = dados

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
          self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
            // SETA OS DADOS RECEBIDOS PARA TABELA
            self.tabela = tabelaSuccess

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()


            // CHAMA A FUNÇÃO PARA FINALIZAR A TABELA
            self.regAteConfigStatusTabelaFinalizar()
          }, self.regAteConfigStatusSetaStatusGeral)
        })
      },
      regAteConfigStatusTabelaBuscaRegistro: function (callback, registros = [], total = null) {
        var self = this

        if (total === null || registros.length < total) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, notificar: null, last_at: null, last_user: { j: { usuario: null } } }, where: { f: 'status', o: '=', v: '1' }, order: { last_at: 'desc' } }
  
          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/reg-atendimento/config/status/get/', 'GET', queryGet, function (apiSuccess) {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA CARREGAR TODOS OS REGISTROS
            self.regAteConfigStatusTabelaBuscaRegistro(callback, registros, Number(apiSuccess.countAll))
          }, self.regAteConfigStatusSetaStatusGeral)
        } else {
          callback(registros)
        }
      },
      regAteConfigStatusTabelaFinalizar: function () {
        // SETA O STATUS DA TABELA
        this.tabela.status = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA PAGINA
        this.regAteConfigStatusSetaStatusGeral('')
      },
      regAteConfigStatusTabelaOnCheckboxAtualiza: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          // PEGA O ID DA COLUNA
          var indexColuna = this.tabela.coluna.findIndex(item => item.chave === coluna)

          // SETA O VALOR RECEBIDO NO CHECKBOX
          this.checkbox = checkbox.filter(item => item !== this.tabela.coluna[indexColuna].chave)
        }
      },
      regAteConfigStatusAbrirFormulario: function (ids = null) {
        // PEGA O REGISTRO QUE DEVE ABRIR O FORMULARIO
        if (ids === null) {
          ids = this.checkbox
        } else {
          ids = [ ids ]
        }

        // MONTA O LINK DE IDS A SER ALTERADO
        ids = ids.length === 1 ? ids[0] : window.btoa(JSON.stringify(ids))

        // CHAMA A ROTA PARA ABRIR A TELA
        this.$router.push({ name: 'reg_ate_config_status_form', params: { id: ids } })
      },
      regAteConfigStatusDeletarRegistro: function () {
        if (window.confirm('Deseja realmente excluir o(s) produto(s) selecionados?')) {
          var self = this

          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          self.tabela.acoes.buttons[1].status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
          var formData = { lot: [] }

          // ADICIONA NO VETOR TODOS OS IDS QUE SERÁ EXCLUIDO
          for (var key in this.checkbox) {
            formData.lot.push({ id: this.checkbox[key] })
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/reg-atendimento/config/status', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, self.regAteConfigStatusTabelaIniciar, 'WEB [200]: Registros excluídos com sucesso.')
          }, function (apiError) {
            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            self.tabela.acoes.buttons[1].status = ''

            // ALTERA O STATUS
            self.tabela.status = apiError

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            self.time = new Date().getTime()
          })
        }
      },
    }
  }
</script>
